"use strict";

var LanduseEsriDynamicMapLayer = function () {
  const esriKey = "soilImpervious";
  const esriLayer = "landuse";
  const layerName = "landuseEsriDynamicMap";
  const layerKey = "landuseEsriDynamicMapLayer";

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    var landuseEsriDynamicMapLayer = new EsriDynamicMapLayer(
      layerName,
      layerKey,
      esriKey,
      esriLayer,
    );
    landuseEsriDynamicMapLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    landuseEsriDynamicMapLayer.loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  return {
    loadLayerListenersForMap,
  };
};

module.exports = LanduseEsriDynamicMapLayer();

const EsriDynamicMapLayer = require("../mapFunctions/esriDynamicMapLayer");
